import { Action } from 'redux';
import { IAsynchronouslyLoadedValue } from '../types';
import { ShipmentTrackingDetail } from '../types/trackingDetails';

export const RETURN_ORDER_TRACKING_CLEAR = 'returnOrderTracking/clear';
export const RETURN_ORDER_TRACKING_GET = 'returnOrderTracking/get';
export const RETURN_ORDER_TRACKING_LOADED = 'returnOrderTracking/loaded';

export interface ReturnOrderTrackingGetAction extends Action {
    type: typeof RETURN_ORDER_TRACKING_GET;
    payload: IAsynchronouslyLoadedValue<ShipmentTrackingDetail[]>;
}

export interface ReturnOrderTrackingLoadedAction extends Action {
    type: typeof RETURN_ORDER_TRACKING_LOADED;
    payload: IAsynchronouslyLoadedValue<ShipmentTrackingDetail[]>;
}

export interface ReturnOrderTrackingClearAction extends Action {
    type: typeof RETURN_ORDER_TRACKING_CLEAR;
    payload: IAsynchronouslyLoadedValue<ShipmentTrackingDetail[]>;
}

export type ReturnOrderTrackingActions =
    | ReturnOrderTrackingGetAction
    | ReturnOrderTrackingLoadedAction
    | ReturnOrderTrackingClearAction;
